import type { AudioDeviceInfo } from '../types';

export const types = {
    START_MAIN_CONNECTION: '@bg/START_MAIN_CONNECTION',
    STOP_MAIN_CONNECTION: '@bg/STOP_MAIN_CONNECTION',
    MAIN_CONNECTION_OPENED: '@bg/MAIN_CONNECTION_OPENED',
    MAIN_CONNECTION_CLOSED: '@bg/MAIN_CONNECTION_CLOSED',

    INIT_LISTENER: '@bg/INIT_LISTENER',

    START_AUDIO_SYSTEM_INFO_CONNECTION: '@bg/START_AUDIO_SYSTEM_INFO_CONNECTION',
    STOP_AUDIO_SYSTEM_INFO_CONNECTION: '@bg/STOP_AUDIO_SYSTEM_INFO_CONNECTION',
    AUDIO_SYSTEM_INFO_CONNECTION_OPENED: '@bg/AUDIO_SYSTEM_INFO_CONNECTION_OPENED',
    AUDIO_SYSTEM_INFO_CONNECTION_CLOSED: '@bg/AUDIO_SYSTEM_INFO_CONNECTION_CLOSED',

    REQUEST_LEGACY_LISTENER_DEVICE_LIST: '@bg/REQUEST_DEVICE_LIST',
    START_AUDIO_DEVICE_CONNECTION: '@bg/START_AUDIO_DEVICE_CONNECTION',

    START_EVENT_FORWARDING_CONNECTION: '@bg/START_EVENT_FORWARDING_CONNECTION',
    EVENT_FORWARDING_CONNECTION_CLOSED: '@bg/EVENT_FORWARDING_CONNECTION_CLOSED',

    EVENT_FORWARDED: '@bg/EVENT_FORWARDED',

    DEVICE_LIST_RECEIVED: '@bg/DEVICE_LIST_RECEIVED',
    DEVICE_LIST_RECEIVE_ERROR: '@bg/DEVICE_LIST_RECEIVE_ERROR',
    DAEMON_VERSION_RECEIVED: '@bg/DAEMON_VERSION_RECEIVED',

    DAEMON_INITIALIZED: '@bg/DAEMON_INITIALIZED',

    GET_SYSTEM_INFORMATION: '@bg/GET_SYSTEM_INFORMATION'
};

type ThunkDispatch = (action: unknown) => unknown;

export const startMainConnection = () => ({
    type: types.START_MAIN_CONNECTION
});

export const stopMainConnection = () => ({
    type: types.STOP_MAIN_CONNECTION
});

export const mainConnectionOpened = () => ({
    type: types.MAIN_CONNECTION_OPENED
});

export const initListener = () => (dispatch: ThunkDispatch) => {
    dispatch({
        type: types.INIT_LISTENER
    });
};

export const mainConnectionClosed = (wasClean: boolean, code?: number) => ({
    type: types.MAIN_CONNECTION_CLOSED,
    payload: { wasClean, code }
});

export const startAudioSystemInfoConnection = (port: number) => ({
    type: types.START_AUDIO_SYSTEM_INFO_CONNECTION,
    payload: { port }
});

export const stopAudioSystemInfoConnection = () => ({
    type: types.STOP_AUDIO_SYSTEM_INFO_CONNECTION
});

export const audioSystemInfoConnectionOpened = () => ({
    type: types.AUDIO_SYSTEM_INFO_CONNECTION_OPENED
});

export const audioSystemInfoConnectionClosed = (wasClean: boolean) => ({
    type: types.AUDIO_SYSTEM_INFO_CONNECTION_CLOSED,
    payload: { wasClean }
});

export const startAudioDeviceConnection = (port: number) => ({
    type: types.START_AUDIO_DEVICE_CONNECTION,
    payload: { port }
});

export const startEventForwardingConnection = (port: number) => ({
    type: types.START_EVENT_FORWARDING_CONNECTION,
    payload: { port }
});

export const eventForwardingConnectionClosed = (wasClean: boolean) => ({
    type: types.EVENT_FORWARDING_CONNECTION_CLOSED,
    payload: { wasClean }
});

export const forwardEvent = ({ jsonRequest }: { jsonRequest: unknown }) => ({
    type: types.EVENT_FORWARDED,
    payload: { jsonRequest }
});

/**
 * @deprecated Old Listener APP
 * @param mics
 * @param speakers
 * @returns {{type: string, payload: {mics: *, speakers: *}}}
 */
export const deviceListReceived = (mics: AudioDeviceInfo[], speakers: AudioDeviceInfo[]) => ({
    type: types.DEVICE_LIST_RECEIVED,
    payload: { mics, speakers }
});

/**
 * @deprecated Old Listener APP
 * @returns {{type: string}}
 */
export const deviceListReceiveError = () => ({
    type: types.DEVICE_LIST_RECEIVE_ERROR
});

export const daemonVersionReceived = (version: string) => ({
    type: types.DAEMON_VERSION_RECEIVED,
    payload: { version }
});

export const daemonInitialized = () => ({
    type: types.DAEMON_INITIALIZED
});

export const getSystemInformation = () => ({ type: types.GET_SYSTEM_INFORMATION });
